<div class="carousel">
  @for (mediaObj of media; track $index) { @if (mediaObj.type === "image") {
  <div
    matRipple
    class="spot-img-container position-relative"
    style="cursor: pointer"
    (click)="imageClick($index)"
  >
    <img [ngSrc]="getSrc(mediaObj)" fill priority />
  </div>
  } }
</div>
